import { HiShieldCheck } from "react-icons/hi"
import { MdCancel, MdAnalytics } from "react-icons/md"

const data = [
    {
        icon: <HiShieldCheck />,
        heading: "Best In Market",
        details: "Best in market Best One to Try It out Best in market Best One to Try It out Best in market Best One to Try It out"
    },
    {
        icon: <MdCancel />,
        heading: "Good In Market",
        details: "Good in market Good One to Try It out Good in market Good One to Try It out Good in market Good One to Try It out"
    },
    {
        icon: <MdAnalytics />,
        heading: "Better In Market",
        details: "Better in market Better One to Try It out Better in market Better One to Try It out Better in market Better One to Try It out"
    }
]

export default data